// FARMS
export const API_VOTING = '/voting/farms';

export const API_VOTING_FARM = '/voting/farms';

export const API_VOTING_DEXES = '/voting/farms/dexes';

export const API_VOTING_CHAINS = '/voting/farms/chains';

export const API_VOTING_FARMS = '/voting/farms';

export const API_VOTING_STATISTICS = '/voting/farms/statistics';
